import $ from 'jquery';
import _ from 'lodash';
/**
 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
 *
 * @see https://github.com/jackmoore/autosize
 * @param context
 */
export default function radioDirective(context=document.body) {
	const $context = $(context);

	const LABELS = $context.find('.radio-button label');

	if (LABELS.length) {
		LABELS.each(function() {
			const RADIO_DOM = $(this);

			RADIO_DOM.click(_.debounce(function(){
				const _THIS = $(this);
				const PARENT = _THIS.parent();
				const INPUT = PARENT.find('> input');
				const GROUP = INPUT.attr('name');

				$('.radio-button > input[name=' + GROUP + ']').parent().removeClass('is-selected');
				PARENT.addClass('is-selected');
			}, 100));
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/radio.js